import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconShieldCheck from '@/assets/icons/heroIcons/ShieldCheck.svg';
import { DownloadButton } from '@/components/buttons';
import { DocumentSection } from '@/sections/documents/DocumentSection';
export function InsuranceConditions(props) {
  const $ = _c(71);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["termsAndConditions"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("categories.5.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconShieldCheck className="h-7 w-7 text-blue-500 lg:h-10 lg:w-10" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("categories.5.text");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <p className="mb-8">{t3}</p>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("categories.5.subtitle");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t5}</h3>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("categories.5.list.1");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <li>{t7}</li>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("categories.5.list.2");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <li>{t9}</li>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("categories.5.list.3");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <li>{t11}</li>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t("categories.5.list.4");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <li>{t13}</li>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t12 || $[30] !== t14 || $[31] !== t8) {
    t15 = <ul className="mb-8 list-disc space-y-3 pl-5 marker:text-blue-500">{t8}{t10}{t12}{t14}</ul>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t14;
    $[31] = t8;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t) {
    t16 = t("categories.5.documents.title");
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16) {
    t17 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t16}</h3>;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t) {
    t18 = t("categories.5.documents.extendedWarrantyInsuranceTerms");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t18) {
    t19 = <div className="mb-2 lg:mb-4"><DownloadButton to="/files/cs/Skippay_Vseobecne_pojistne_podminky_pro_pojisteni_prodlouzene_zaruky.pdf" testId="extendedWarrantyInsuranceTerms" analyticsParam="extendedWarrantyInsuranceTerms" className="sm:w-full">{t18}</DownloadButton></div>;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t) {
    t20 = t("categories.5.documents.accidentalDamageAndTheftInsuranceTerms");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t20) {
    t21 = <div className="mb-2 lg:mb-4"><DownloadButton to="/files/cs/Skippay_Vseobecne_pojistne_podminky_pro_pojisteni_nahodneho_poskozeni_a_odcizeni.pdf" testId="accidentalDamageAndTheftInsuranceTerms" analyticsParam="accidentalDamageAndTheftInsuranceTerms" className="sm:w-full">{t20}</DownloadButton></div>;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t) {
    t22 = t("categories.5.documents.infolist");
    $[45] = t;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t22) {
    t23 = <div className="mb-2 lg:mb-4"><DownloadButton to="/files/cs/Skippay_Infolist_produktu_Informace_pojistitele_pro_zajemce_o_pojisteni.pdf" testId="infolist" analyticsParam="infolist" className="sm:w-full">{t22}</DownloadButton></div>;
    $[47] = t22;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t) {
    t24 = t("categories.5.documents.ipid");
    $[49] = t;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t24) {
    t25 = <div className="mb-2 lg:mb-4"><DownloadButton to="/files/cs/Skippay_Informatni_dokument_o_pojistnem_produktu.pdf" testId="ipid" analyticsParam="ipid" className="sm:w-full">{t24}</DownloadButton></div>;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t) {
    t26 = t("categories.5.documents.contract");
    $[53] = t;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== t26) {
    t27 = <DownloadButton to="/files/cs/Skippay_Pojistna_smlouva.pdf" testId="contract" analyticsParam="contract" className="sm:w-full">{t26}</DownloadButton>;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t19 || $[58] !== t21 || $[59] !== t23 || $[60] !== t25 || $[61] !== t27) {
    t28 = <div className="inline-block">{t19}{t21}{t23}{t25}{t27}</div>;
    $[57] = t19;
    $[58] = t21;
    $[59] = t23;
    $[60] = t25;
    $[61] = t27;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== props || $[64] !== t1 || $[65] !== t15 || $[66] !== t17 || $[67] !== t28 || $[68] !== t4 || $[69] !== t6) {
    t29 = <DocumentSection title={t1} icon={t2} {...props}>{t4}{t6}{t15}{t17}{t28}</DocumentSection>;
    $[63] = props;
    $[64] = t1;
    $[65] = t15;
    $[66] = t17;
    $[67] = t28;
    $[68] = t4;
    $[69] = t6;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  return t29;
}